/*
 * Lógica del snippet letters-by-variant. 
 */
(function () {
  if (window.__lettersVariantInit) return;
  window.__lettersVariantInit = true;

  var BUY_BUTTONS = '#AddToCart, button[name="add"], [id^="buy-now-btn"]';
  var PAYMENT_BUTTONS = '.shopify-payment-button, [data-shopify="payment-button"]';
  var instances = [];
  var counter = 0;

  // Mayúsculas, sin tildes, solo A-Z. Devuelve el texto limpio y si se descartó algo.
  function clean(raw) {
    var base = raw.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
    var only = base.replace(/[^A-Z]/g, '');
    return { text: only, dropped: only.length !== base.length };
  }

  function plural(k) { return k + (k === 1 ? ' letra' : ' letras'); }

  function create(root) {
    var uid = ++counter;
    var touched = false;   // el cliente ya interactuó o intentó comprar
    var notice = false;    // se descartaron caracteres no permitidos en la última edición
    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-lv-data]').textContent); } catch (e) {}

    var input = root.querySelector('.lv__input');
    var label = root.querySelector('.lv__label');
    var msg = root.querySelector('[data-lv-msg]');
    var note = root.querySelector('[data-lv-note]');
    var inDrawer = !!root.closest('.side-panel, #Product-Drawer, [id^="Product-Drawer"]');

    // ids únicos por instancia (la misma página puede tener el campo de la página y el del drawer)
    input.id = 'lv-input-' + uid;
    label.setAttribute('for', input.id);
    msg.id = 'lv-msg-' + uid;
    note.id = 'lv-note-' + uid;
    input.setAttribute('aria-describedby', msg.id + ' ' + note.id);

    function scope() {
      return root.closest('[id^="ProductInfo-"]') || root.closest('.side-panel-content') || document;
    }
    function form() { return root.closest('form'); }

    function buySelector() {
      var extra = (root.dataset.extraButtons || '').trim();
      return BUY_BUTTONS + (extra ? ', ' + extra : '');
    }

    function lettersFor(variantId) {
      var v = variants[variantId];
      var m = v && /(\d+)\s*letra/i.exec(v.t);
      return m ? parseInt(m[1], 10) : 0;
    }

    // ---- Cómo averiguamos la variante elegida ----
    function fromUrl() {
      var id = new URLSearchParams(location.search).get('variant');
      return id && variants[id] ? { vid: id } : null;
    }
    function fromOptions() {
      var s = scope();
      var vs = s.querySelector ? (s.querySelector('variant-selects') || s) : s;
      var values = [];
      vs.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) {
        if (el.name === 'id') return;
        var v = el.tagName === 'SELECT' ? el.value : el.value;
        if (v) values.push(v);
      });
      if (!values.length) return null;
      var title = values.join(' / ').toLowerCase();
      var ids = Object.keys(variants);
      for (var i = 0; i < ids.length; i++) {
        if (variants[ids[i]].t.toLowerCase() === title) return { vid: ids[i] };
      }
      // No coincide el título completo (p. ej. otras opciones): nos basta con el valor "N letras"
      for (var j = 0; j < values.length; j++) {
        var m = /^\s*(\d+)\s*letras?\s*$/i.exec(values[j]);
        if (m) return { n: parseInt(m[1], 10) };
      }
      return null;
    }
    function fromIdInput() {
      var f = form();
      if (!f) return null;
      var ids = f.querySelectorAll('[name="id"]');
      for (var i = ids.length - 1; i >= 0; i--) if (variants[ids[i].value]) return { vid: ids[i].value };
      return null;
    }
    function fromInitial() {
      var id = root.dataset.initialVariant;
      return id && variants[id] ? { vid: id } : null;
    }

    function resolve() {
      // En la página la URL se actualiza con la variante; en el drawer no, así que se lee de las opciones.
      var order = inDrawer ? [fromOptions, fromIdInput, fromInitial] : [fromUrl, fromOptions, fromIdInput, fromInitial];
      for (var i = 0; i < order.length; i++) {
        var r = order[i]();
        if (r && (r.vid || r.n)) return { vid: r.vid || null, n: r.n || lettersFor(r.vid) };
      }
      return { vid: null, n: 0 };
    }

    function status() {
      var r = resolve();
      var value = input.value;
      var len = value.length;
      var valid = r.n > 0 && len === r.n && /^[A-Z]+$/.test(value);
      return { vid: r.vid, n: r.n, len: len, valid: valid, value: value };
    }

    function errorText(s) {
      if (s.len === 0) return 'Escribe las ' + s.n + ' letras para tu pedido.';
      if (s.len < s.n) return 'Faltan ' + plural(s.n - s.len) + '.';
      if (s.len > s.n) return 'Sobran ' + plural(s.len - s.n) + '.';
      return 'Solo se permiten letras.';
    }

    function lockButtons(lock, available) {
      scope().querySelectorAll(buySelector()).forEach(function (btn) {
        if (lock) {
          if (!btn.disabled) { btn.disabled = true; btn.dataset.lvLocked = '1'; }
        } else if (btn.dataset.lvLocked) {
          delete btn.dataset.lvLocked;
          if (available !== false) btn.disabled = false;   // no reactivar si la variante está agotada
        }
      });
    }

    function draw() {
      var s = status();
      var active = s.n > 0;

      root.hidden = !active;
      input.disabled = !active;                 // desactivado => no se envía properties[Mensaje]
      if (!active) { lockButtons(false, true); return; }

      // setAttribute (no las propiedades): asignar minLength > maxLength lanza IndexSizeError al subir el número de letras
      input.setAttribute('maxlength', s.n);
      input.setAttribute('minlength', s.n);

      var showError = !s.valid && (touched || s.len > 0);
      input.setAttribute('aria-invalid', String(showError));

      root.querySelector('[data-lv-title]').textContent = (root.dataset.heading || 'Escribe las [n] letras').replace('[n]', s.n);
      root.querySelector('[data-lv-counter]').textContent = s.len + ' / ' + s.n;
      root.classList.toggle('is-valid', s.valid);
      root.classList.toggle('is-invalid', showError);

      if (s.valid) msg.textContent = 'Perfecto, tu texto está completo.';
      else if (showError) msg.textContent = errorText(s);
      else msg.textContent = 'Solo letras (A-Z). Sin espacios, números ni símbolos.';

      note.textContent = notice ? 'Se eliminaron los caracteres no permitidos: solo se aceptan letras.' : '';

      var variant = s.vid && variants[s.vid];
      lockButtons(!s.valid, variant ? variant.a : true);
    }

    function render() {
      try { draw(); } catch (err) { console.error('[letters-by-variant]', err); }
    }

    function blocked() {
      var s = status();
      return s.n > 0 && !s.valid;
    }

    function attempt() {
      touched = true;
      render();
      input.focus();
      input.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function onInput() {
      var n = status().n;
      var caret = input.selectionStart == null ? input.value.length : input.selectionStart;
      var res = clean(input.value);
      var text = n > 0 ? res.text.slice(0, n) : res.text;
      var caretClean = clean(input.value.slice(0, caret)).text.length;
      notice = res.dropped;
      if (text !== input.value) {
        input.value = text;
        try { input.setSelectionRange(Math.min(caretClean, text.length), Math.min(caretClean, text.length)); } catch (err) {}
      }
      render();
    }

    return {
      root: root,
      input: input,
      scope: scope,
      form: form,
      buySelector: buySelector,
      render: render,
      blocked: blocked,
      attempt: attempt,
      onInput: onInput,
      touch: function () { touched = true; render(); },
      status: status
    };
  }

  // ---- Alta de instancias (incluye las que se inyectan después, como el drawer) ----
  function scan() {
    instances = instances.filter(function (i) { return i.root.isConnected; });
    document.querySelectorAll('[data-lv-root]').forEach(function (root) {
      if (root.__lv) return;
      root.__lv = create(root);
      instances.push(root.__lv);
    });
  }
  function refreshAll() {
    scan();
    instances.forEach(function (i) { i.render(); });
  }
  function refreshSoon() { setTimeout(refreshAll, 0); setTimeout(refreshAll, 150); setTimeout(refreshAll, 500); }

  var scanQueued = false;
  new MutationObserver(function () {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () { scanQueued = false; refreshAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  function instanceOf(target) {
    var root = target && target.closest && target.closest('[data-lv-root]');
    return root && root.__lv;
  }

  // ---- Edición del campo ----
  document.addEventListener('input', function (e) {
    var inst = instanceOf(e.target);
    if (inst && e.target === inst.input && !e.isComposing) inst.onInput();
  });
  document.addEventListener('compositionend', function (e) {
    var inst = instanceOf(e.target);
    if (inst && e.target === inst.input) e.target.dispatchEvent(new Event('input', { bubbles: true }));
  });
  document.addEventListener('focusout', function (e) {
    var inst = instanceOf(e.target);
    if (inst && e.target === inst.input) inst.touch();
  });

  // ---- Cambios de variante: se escucha en todo el documento (los radios usan form="..." y pueden estar fuera del <form>) ----
  document.addEventListener('change', function (e) { if (!instanceOf(e.target)) refreshSoon(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('fieldset, [data-index], label, variant-selects, variant-radios')) refreshSoon();
  });
  ['variant:change', 'product:variant-change', 'variantChange'].forEach(function (name) {
    document.addEventListener(name, refreshSoon);
  });
  ['pushState', 'replaceState'].forEach(function (fn) {
    var orig = history[fn];
    history[fn] = function () { var r = orig.apply(this, arguments); refreshSoon(); return r; };
  });
  window.addEventListener('popstate', refreshSoon);

  // ---- Bloqueo de envío / compra ----
  document.addEventListener('submit', function (e) {
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (inst.root.isConnected && e.target === inst.form() && inst.blocked()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        inst.attempt();
        return;
      }
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!inst.root.isConnected || !inst.blocked()) continue;
      var btn = e.target.closest(inst.buySelector() + ', ' + PAYMENT_BUTTONS);
      if (btn && inst.scope().contains(btn)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        inst.attempt();
        return;
      }
    }
  }, true);

  window.__lettersVariantDebug = function () {
    return instances.map(function (i) { return { status: i.status(), connected: i.root.isConnected }; });
  };

  setInterval(refreshAll, 400);   // red de seguridad si el tema cambia la variante sin emitir eventos
  refreshAll();
})();
